import config from 'config';
import cdn from 'cdnImagePreprocessor';

export default [
  '$sce', '$stateParams', 'CobrandedAPISerice', 'ErrorHandler',
  class CobrandController {
    constructor($sce, $stateParams, CobrandedAPISerice, ErrorHandler) {
      this._$sce = $sce;
      this._$stateParams = $stateParams;
      this._cobrandedAPIService = CobrandedAPISerice;
      this._errorHandler = ErrorHandler;
      this._init();
    }

    _init() {
      this.pid = this._$stateParams.pid;

      this.logoPath = cdn(config).asset(`/${this.pid}/inverted.png`);

      this._initConfigData(this.pid)
        .then((res) => this._setConfigData(res))
        .catch((err) => this._configError(err));
    }

    _initConfigData(pid) {
      return this._cobrandedAPIService.getRegistrationData(pid);
    }

    _setConfigData(res) {
      this.headlineHtml = this._$sce.trustAsHtml(res.headline);
      this.subheaderHtml = this._$sce.trustAsHtml(res.subheader);
      this.paragraphHtml = this._$sce.trustAsHtml(res.paragraph);
    }

    _configError(err) {
      this._errorHandler.throwError('Partner Error', 'An error occurred while attempting to retrieve partner data. Please try again.', { rawError: err })
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/pages/cobrand/cobrand-register/cobrand-register.ctrl.js